/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setDrawerButton.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * ドロワーナビゲーションボタン
 */
const setDrawerButton = () => {
  let html = document.querySelector('html');
  let DrawerButton = document.querySelectorAll('.drawerButton__toggle');
  let Links = document.querySelectorAll('.drawerNav a');
  let headerHeight = document.querySelector('header').offsetHeight;

  // ドロワーナビオープンorクローズ
  const navOpen = () => {
    html.classList.add("--open");
  }

  // ドロワーナビクローズ
  const navClose = () => {
    html.classList.remove("--open");
  }

  // ドロワーボタンクリック時
  DrawerButton.forEach((btn) => {
    btn.addEventListener("click", () => {
      if (html.classList.contains("--open")) {
        navClose();
      } else {
        navOpen();
      }
    });
  })

  // アンカーリンククリック時
  Links.forEach((link) => {
    link.addEventListener("click", (e) => {
      if(e.currentTarget.getAttribute("href").indexOf("#") === -1) return;
      let href = e.currentTarget.getAttribute("href");
      let targetId = href.substring(href.indexOf("#"));
      let target = document.querySelector(targetId);
      if (target) {
        navClose();
        e.preventDefault();
        let targetOffsetTop = window.pageYOffset + target.getBoundingClientRect().top - headerHeight;
        window.scrollTo({
          top: targetOffsetTop,
          behavior: "smooth",
        });
      }
    });
  })
};

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export {
  setDrawerButton
};